import { RevolvaService, ProductInfo, ProductList, PiecesInfo } from './revolva.service';
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { RoughnessMipmapper } from "three/examples/jsm/utils/RoughnessMipmapper.js";
import * as THREE from "three";
import * as actionsCustom from "@/service/revolva.action-custom";


export function loadGround(service: RevolvaService) {
    const { scene } = service
    const loader = new THREE.TextureLoader();
    const groundTexture = loader.load('../../textures/ground.jpg');
    groundTexture.wrapS = groundTexture.wrapT = THREE.RepeatWrapping;
    groundTexture.repeat.set(1, 1);
    groundTexture.anisotropy = 16;
    groundTexture.encoding = THREE.sRGBEncoding;

    const groundMaterial = new THREE.MeshLambertMaterial({ map: groundTexture });

    const mesh = new THREE.Mesh(new THREE.PlaneBufferGeometry(1.5, 1.5), groundMaterial);
    mesh.position.y = - 0.2;
    mesh.rotation.x = - Math.PI / 2;
    //mesh.receiveShadow = true;
    scene.add(mesh);
}


export function renderModel(service: RevolvaService) {
    const { renderer, scene, camera, animation, controls, controlerAutoRotat, mixer, clock } = service
   // console.log("renderMode");
    if (animation) {
        //console.log("animation");
        setTimeout(function () {
            requestAnimationFrame(() => renderModel(service));
            if (controlerAutoRotat) {
                controls.update();
            }
            actionsCustom.watchAnimation(service)
            if (mixer) mixer.update(clock.getDelta());
            // stats.update();
        }, 1000 / 9);

        
       // console.log(mixer)
    }

    renderer.render(scene, camera);
    //controls.update();
}


export function onWindowResize(service: RevolvaService) {
    const { camera, renderer, canvaFullScreen, canvaHeight, canvasWidth } = service
    let tempCavasH = canvaHeight;
    let tempCavasW = canvasWidth;
    if (canvaFullScreen
    ) {
        tempCavasH =
            document.getElementById("model-container").offsetHeight;
        tempCavasW =
            document.getElementById("model-container").offsetWidth;
    }

    camera.aspect = tempCavasW / tempCavasH;
    camera.updateProjectionMatrix();
    renderer.setSize(tempCavasW, tempCavasH);

    renderModel(service);
}



/* export function changePiecesInScene(service: RevolvaService, choiceUuid: string, type: string) {
    const { scene, productsInfo, pieces, piecesInScene, finishedLoading3D, piecesInfo } = service
    if (finishedLoading3D) {
        if (type === 'shop.option.bag.type') {
            const item = productsInfo.filter(
                function (item) { return item.uuid == choiceUuid }
            );
            const product = item[0]
            const piece = product.piece
            const id = product.id
            scene.remove(piecesInScene[piece]);
            piecesInScene[piece] = pieces[id];
            scene.add(piecesInScene[piece]);
            renderModel(service);
        }
        if (type === 'shop.option.bag.color') {
            const item = piecesInfo.filter(
                function (item) { return item.uuid == choiceUuid }
            );
            const product = item[0]
            const path =
                "../../productsList/" +
                product.product +
                "/" +
                product.piece +
                "/" +
                product.color +
                "/" +
                //service.stats = Stats();
                product.file;
            const textureLoader = new THREE.TextureLoader();
            const texture = textureLoader.load(path,

                // onLoad callback
                function (texture) {
                    texture.flipY = false;
                    const piece = product.piece
                    //const id = product.id
                    // scene.remove(piecesInScene[piece]);
                    piecesInScene[piece].children[2].traverse((obj) => {
                        if (obj.isMesh) {
                            // console.log(obj)
                            // note: for a multi-material mesh, `o.material` may be an array,
                            // in which case you'd need to set `.map` on each value.
                            obj.material.map = texture;
                            obj.material.map.needsUpdate = true;
                        }
                    });
                    //scene.add(piecesInScene[piece]);
                    renderModel(service);
                    //console.log(piecesInScene[piece]);
                    // console.log("color")
                },

                // onProgress callback currently not supported
                undefined,

                // onError callback
                function (err) {
                    console.error('An error happened.');
                }
            );

        }

    }
} */

export function init(service: RevolvaService) {
    const { scene, canvas, camera, renderer, controls, light, ground, controlerAutoRotat, controlerRotatOnlyOnX } = service;

    camera.position.set(0, 0, 1);

    renderer.setClearColor(0x000000, 0);
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(canvas.clientWidth, canvas.clientHeight, false);
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    //renderer.toneMappingExposure = 0.8;
    //renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.domElement.style.outline = "none";
    renderer.shadowMap.enabled = true;
    //renderer.shadowMap.type = THREE.PCFShadowMap; 
    renderer.toneMapping = THREE.ReinhardToneMapping;
    renderer.toneMappingExposure = 5;
    const pmremGenerator = new THREE.PMREMGenerator(renderer);
    pmremGenerator.compileEquirectangularShader();
    //scene.add(new THREE.AmbientLight(0x666666));

    light.position.set(0, 2, 2);
    //light.castShadow = true;
    light.shadow.bias = -0.00001;
    light.shadow.mapSize.width = 1024 * 8;
    light.shadow.mapSize.height = 1024 * 8;
    light.shadow.radius = 2;

    /* const d = 300;

    light.shadow.camera.left = - d;
    light.shadow.camera.right = d;
    light.shadow.camera.top = d;
    light.shadow.camera.bottom = - d; */

    light.shadow.camera.far = 3;

    //const hemiLight = new THREE.HemisphereLight(0xffeeb1, 0x080820, 4);
    //scene.add(hemiLight);

    //const color = 0xFFFFFF;
    //const intensity = 1;
    //const lightA = new THREE.AmbientLight(color, intensity);
    //scene.add(lightA);




    scene.add(light);

    const newLight = new THREE.DirectionalLight(0xffffff, 1);
    newLight.position.set(0, 0, -2);
    newLight.castShadow = false;
    scene.add(newLight);

    const newLightA = new THREE.DirectionalLight(0xffffff, 0.1);
    newLightA.position.set(0, 0, 0.02);
    newLightA.castShadow = false;
    //scene.add(newLightA);

    const helper = new THREE.DirectionalLightHelper(light);
    //scene.add(helper);

    const helpera = new THREE.DirectionalLightHelper(newLight);
    //scene.add(helpera);

    const helperb = new THREE.DirectionalLightHelper(newLightA);
    //scene.add(helperb);


    if (ground) {
        loadGround(service);
    }


    new RGBELoader()
        .setDataType(THREE.UnsignedByteType)
        .load("../../textures/test4.hdr", (texture) => {
            const envMap = pmremGenerator.fromEquirectangular(texture).texture;
            scene.environment = envMap;
            renderer.render(scene, camera);
            texture.dispose();
            pmremGenerator.dispose();
            //scene.background = envMap;
        });


    controls.addEventListener("change", () => renderer.render(scene, camera)); // use if there is no animation loop
    controls.minDistance = 0.65;
    controls.maxDistance = 1.5;
    if (controlerRotatOnlyOnX) {
        controls.minPolarAngle = Math.PI / 2;
        controls.maxPolarAngle = Math.PI / 2;
    }
    controls.target.set(0, 0, 0);
    controls.autoRotate = controlerAutoRotat;
    //controls.autoRotateSpeed = 20;
    controls.update();

    renderModel(service);
}

export function startLoad3d(service: RevolvaService) {
    let { loading3D } = service
    const { scene, camera, controls, productId, productsInfo, productsList, roughnessMipmapper, pieces, piecesInScene } = service
    if (!loading3D) {
        loading3D = true;
        const element = document.getElementById("loading3dDev");
        if (element) {
            element.parentNode.removeChild(element);
        }

        // renderModel(service);
        const productFolder = productsList[productId].product;
        // use of RoughnessMipmapper is optional

        const manager = new THREE.LoadingManager();

        manager.onLoad = async () => {
            /* finishedLoading3D = true; */
        };
        const loader = new GLTFLoader(manager);

        productsInfo.forEach((item) => {
            if (item.product == productFolder) {
                const path =
                    "../../productsList/" +
                    item.product +
                    "/" +
                    item.piece +
                    "/" +
                    item.spec +
                    "/" +
                    //service.stats = Stats();
                    item.file;

                loader.load(path, async (gltf) => {
                    const materialFunction = (child: THREE.Object3D): void => {
                        if (child instanceof THREE.Mesh) {
                            roughnessMipmapper.generateMipmaps(
                                (child as any).material // eslint-disable-line @typescript-eslint/no-explicit-any

                            );

                           /*  if (item.piece === 'piece2'){
                                child.receiveShadow = true;
                                child.castShadow = true; 
                            } */
                             
                            if (child.name === 'dail' || child.name === 'dail001') {
                                child.receiveShadow = true;
                            }
                            if (["piece4", "piece5", "piece6"].includes(item.piece))
                                child.castShadow = true; 


                        }



                    };

                    gltf.scene.traverse(materialFunction);
                    roughnessMipmapper.dispose();
                    pieces[item.id] = gltf.scene;

                    if (item.default == 1) {
                        scene.add(gltf.scene);
                        piecesInScene[item.piece] = gltf.scene;


                    }
                    if (item.lookAt == 1) {
                        camera.lookAt(gltf.scene.position);
                        const helper = new THREE.BoxHelper(gltf.scene);
                        helper.geometry.computeBoundingBox();
                        const center = helper.geometry.boundingBox.getCenter(new THREE.Vector3);
                        gltf.scene.localToWorld(center);

                        controls.target.set(center.x, center.y, center.z);
                        controls.update();
                        //renderModel(service);
                    }

                    if (item.piece == 'piece8') {
                        actionsCustom.rotatMesh(service);
                    }

                    if (item.piece == 'piece7') {
                        //adding animation
                        const animations = gltf.animations;

                        service.mixer = new THREE.AnimationMixer(gltf.scene);

                        for (let i = 0; i < animations.length; i++) {
                            const animation = animations[i];
                            // alert(animations.length);
                            //alert(item.id);
                            // There's .3333 seconds junk at the tail of the Monster animation that
                            // keeps it from looping cleanly. Clip it at 3 seconds
                            //if ( item.animationTime ) {

                            //							animation.duration = animations.length;

                            //							}

                            const action = service.mixer.clipAction(animation);

                            action.play();
                        }


                    }
                    renderModel(service);
                });
            } //end of product
        }); //end of for each productsInfo
    } //end of if loading 3d
}

export function changePiecesInScene(service: RevolvaService, piece: string, id: number) {
    const { scene,  pieces,  piecesInScene } = service
    scene.remove(piecesInScene[piece]);
    piecesInScene[piece] = pieces[id];
    scene.add(piecesInScene[piece]);
    renderModel(service);
}


export function setProductId(service: RevolvaService, productId: number) {
    service.productId = productId;
}

export function setproductsListJson(service: RevolvaService, productsListJson: ProductList[]) {
    service.productsList = productsListJson;
}

export function setProductsInfo(service: RevolvaService, productsInfo: ProductInfo[]) {
    service.productsInfo = productsInfo;
}

export function setPiecesInfo(service: RevolvaService, piecesInfo: PiecesInfo[]) {
    service.piecesInfo = piecesInfo;
}

export function setCanvaHeight(service: RevolvaService, canvaHeight: number) {
    service.canvaHeight = canvaHeight;
}

export function setCanvaWeight(service: RevolvaService, canvasWidth: number) {
    service.canvasWidth = canvasWidth;
}

export function setCanvaSize(service: RevolvaService, canvasWidth: number, canvaHeight: number) {
    service.canvasWidth = canvasWidth;
    service.canvaHeight = canvaHeight;
}

export function setCameraAspect(service: RevolvaService) {
    service.camera.aspect = service.canvasWidth / service.canvaHeight;
}


export function setCanvas(service: RevolvaService, canvas: HTMLCanvasElement) {
    service.canvas = canvas;
}

export function setMainObjects(service: RevolvaService) {
    service.camera = new THREE.PerspectiveCamera(
        45,
        service.canvasWidth / service.canvaHeight,
        0.25,
        100
    );
    service.scene = new THREE.Scene();
    service.scene.background = new THREE.Color(0x000000);
    //Load background texture
   /*  const loader = new THREE.TextureLoader();
    loader.load('../../textures/black.jpg', function (texture) {
        console.log('tt');
        service.scene.background = texture;
    }); */
    service.renderer = new THREE.WebGLRenderer({ canvas: service.canvas, antialias: true, alpha: true });
    service.renderer.setSize(service.canvasWidth, service.canvaHeight);
    service.controls = new OrbitControls(service.camera, service.renderer.domElement);
    service.roughnessMipmapper = new RoughnessMipmapper(service.renderer);
    //service.light = new THREE.DirectionalLight(0xffa95c, 8);
    service.light = new THREE.DirectionalLight(0xffffff, 1);

    service.clock = new THREE.Clock();
}

export function setCanvafullScreen(service: RevolvaService, status: boolean) {
    service.canvaFullScreen = status
}